import { ReactNode, createContext, useState } from 'react'


const ReservationFormContext = createContext({});

export const ReservationFormProvider = ({ children }: { children: ReactNode }) => {
    const [showPopup, setShowPopup] = useState<boolean>(false);

    const value = { showPopup, setShowPopup };

    return (
        <ReservationFormContext.Provider value={value}>
            {children}
        </ReservationFormContext.Provider>
    )
}

export default ReservationFormContext
